import { formatPrice } from './format';

// метод для получения данных из merchant/check и прокидывания их в notify1c во всех существующих вызовах в проекте
export default function getExtraNotify1cData(_tx) { // tx это result из merchant/check
  const result = {};
  let tx;

  if (_tx.dst && _tx.dst.extra) {
    tx = _tx.dst.extra;
  } else if (_tx.dst_extra) {
    tx = _tx.dst_extra;
  } else if (_tx.dst_extras) {
    tx = _tx.dst_extras;
  } else {
    tx = _tx;
  }

  if (tx) {
    result.PhoneNumber = tx.phone || tx.Phone;
    result.commission = formatPrice(tx.comission);
    result.payment_amount = formatPrice(tx.amount);

    if (tx.startESPP === 'true') {
      result.intent = 'startESPP';
    }
  }

  if (_tx.merchant_tx && _tx.merchant_tx.merchant_id) {
    result.merchant = _tx.merchant_tx.merchant_id;
  }

  return result; //TODO!!! все новые параметры, надо добавить в пропсы processing.js/sendNotify
}
